import config from "config/config";
import { getToken } from "js/formatting/getToken";

export async function getFormsByCategories(
  PolicyId,
  Company,
  IssueState,
  ResidentState,
  ProductType,
  UserId
) {
  let options = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ClientSecret: config.PORTAL_CLIENT_SECRET,
      Authorization: `bearer ${getToken()}`,
    },
  };
  let url =
    config.REG_API_BASE_URL +
    "/Forms?Portal=customer" +
    "&PolicyId=" +
    PolicyId +
    "&Company=" +
    Company +
    "&IssueState=" +
    IssueState +
    "&ResidentState=" +
    ResidentState +
    "&ProductType=" +
    ProductType +
    (UserId ? "&UserId=" + encodeURIComponent(UserId) : "");

  const response = await fetch(`${url}`, options);
  if (!response.ok) {
    throw response;
  } else {
    const data = await response.json();
    return data;
  }
}
